// extracted by mini-css-extract-plugin
export default {"title":"FittingsContainer_title__xJXzx"};